// Medalhas por mapa (docs/03): Autor = tempo real de playtest; derivação padrão.
export type Medal = 'author' | 'gold' | 'silver' | 'bronze' | null;

export interface MedalTimes {
  authorMs: number;
  goldMs: number;
  silverMs: number;
  bronzeMs: number;
}

const round250 = (ms: number): number => Math.round(ms / 250) * 250;

/** Ouro = autor×1.10 · Prata = ×1.27 · Bronze = ×1.60 (docs/03) */
export function deriveMedals(authorMs: number): MedalTimes {
  return {
    authorMs,
    goldMs: round250(authorMs * 1.1),
    silverMs: round250(authorMs * 1.27),
    bronzeMs: round250(authorMs * 1.6),
  };
}

export function medalFor(timeMs: number, t: MedalTimes): Medal {
  if (timeMs <= t.authorMs) return 'author';
  if (timeMs <= t.goldMs) return 'gold';
  if (timeMs <= t.silverMs) return 'silver';
  if (timeMs <= t.bronzeMs) return 'bronze';
  return null;
}

export const MEDAL_LABEL: Record<Exclude<Medal, null>, string> = {
  author: 'AUTOR', gold: 'OURO', silver: 'PRATA', bronze: 'BRONZE',
};
export const MEDAL_ICON: Record<Exclude<Medal, null>, string> = {
  author: '💎', gold: '🥇', silver: '🥈', bronze: '🥉',
};
